import * as React from 'react';

import "./index.scss";

type Props = {
  withInput?: boolean,
  withBorder?: boolean,
  isOpen?: boolean,
  title: string,
  onArrowPress?(): void,
  iconId?: number,
  index?: number,
  headingLevel?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const Section: React.FunctionComponent<Props> = ({
  withInput,
  withBorder,
  isOpen,
  title,
  onArrowPress,
  iconId,
  index,
  headingLevel = 'h2'
}: Props): JSX.Element => {
  const iconRef = React.createRef<any>()

  const toggleSection = (id) => {
    if (onArrowPress) {
      onArrowPress()
    }

    if (iconRef.current) {
      iconRef.current.classList.contains('active')
        ? iconRef.current.classList.remove('active')
        : iconRef.current.classList.add('active')
    }
  }

  const HeadingTag = headingLevel;

  return (
    <div id={`section_${index}`} className="section" onClick={toggleSection}>
      <HeadingTag
        className="section__title app-text"
      >
        {title}
        {
          withBorder && (
            <div id={`section_arrow_${index}`}>
              <i ref={iconRef} className="fal fa-angle-down section__icon"/>
            </div>
          )
        }
      </HeadingTag>
    </div>
  );
};

export default Section;